import type { Api } from '@cocoonspace/types/shared/api'
import type { AxiosInstance, AxiosRequestConfig } from 'axios'

import { defineEndpoint } from '../utils/define-endpoint'

export interface ListTopGuests {
	params?: NonNullable<Api.Operations['listTopGuests']['parameters']>['query']
	response: Api.Operations['listTopGuests']['responses']['200']['content']['application/json']
}

export const listTopGuests = (
	axiosInstance: AxiosInstance,
	overideConfig?: AxiosRequestConfig,
) =>
	defineEndpoint<ListTopGuests>(
		{
			method: 'get',
			url: '/events/guests/top',
			...overideConfig,
		},
		axiosInstance,
	)
